const variants = {
  primary: "bg-slate-900 text-white shadow-sm hover:bg-slate-800",
  secondary: "border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:hover:border-slate-600",
  ghost: "border border-transparent text-slate-700 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-900/70",
  danger: "bg-rose-600 text-white hover:bg-rose-500",
  success: "bg-emerald-600 text-white shadow-sm hover:bg-emerald-700",
};

export default function Button({
  children,
  variant = "primary",
  className = "",
  ...rest
}) {
  const cls = variants[variant] || variants.primary;
  return (
    <button
      className={`px-4 py-2 rounded-xl text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 dark:focus-visible:ring-indigo-700 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 ${cls} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
